import { Typography } from '@mui/material';
import { Box, useMediaQuery, useTheme } from '@mui/system';
import React, { FC } from 'react';

import {
  formatToCurrency,
  isAustralia,
  isUS,
} from 'infrastructure/targets/web/modules/common/helpers';
import { getFirstTimeLessonImage } from 'infrastructure/targets/web/modules/common/imageUrlHelpers';

import {
  StyledCompactCardContainer,
  StyledContentContainer,
  StyledReserveButton,
  StyledTopCardContent,
} from './style';

interface IFirstTimeLessonCardCompact {
  onCardClick: () => void;
  content: string;
  instructorsLoading: boolean;
}

const FirstTimeLessonCardCompact: FC<IFirstTimeLessonCardCompact> = ({
  onCardClick,
  content,
  instructorsLoading,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const imageSize = isMobile
    ? { width: '40px', height: '40px' }
    : { width: '204px', height: '204px' };

  return (
    <StyledCompactCardContainer>
      <StyledTopCardContent>
        <Box
          component="img"
          src={getFirstTimeLessonImage()}
          alt="First Time Lesson"
          sx={{ ...imageSize, borderRadius: '8px', objectFit: 'cover' }}
        />
      </StyledTopCardContent>
      <StyledContentContainer>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 800, marginBottom: '8px' }}>
            First Time Lesson
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary', marginBottom: '16px' }}>
            {content}
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: '100%',
            gap: '16px',
            [theme.breakpoints.down('sm')]: {
              flexDirection: 'column',
              alignItems: 'stretch',
              gap: '12px',
            },
          }}>
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'baseline', 
              gap: '4px', 
              marginLeft: 'auto',
              [theme.breakpoints.down('sm')]: {
                marginLeft: 0,
                justifyContent: 'center',
              },
            }}>
            <Typography
              variant="h3"
              sx={{
                color: '#F50057',
                fontFamily: 'Womby',
                fontWeight: '400',
                fontSize: 18,
              }}>
              {isUS
                ? formatToCurrency(99)
                : isAustralia()
                ? formatToCurrency(199)
                : formatToCurrency(500)}
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.primary' }}>
              / 1 Hour
            </Typography>
          </Box>
          <StyledReserveButton
            variant="contained"
            color="primary"
            disabled={instructorsLoading}
            onClick={onCardClick}>
            Reserve Now
          </StyledReserveButton>
        </Box>
      </StyledContentContainer>
    </StyledCompactCardContainer>
  );
};

export default FirstTimeLessonCardCompact;
